var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('center',[_c('br'),_c('img',{attrs:{"alt":"logo","src":require("../assets/img/logo.svg"),"width":_vm.width}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }